import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('tenome-admin-token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/admin/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAdmin(response.data);
        } catch (error) {
          localStorage.removeItem('tenome-admin-token');
          setToken(null);
          setAdmin(null);
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/admin/login`, { email, password });
    const { token: newToken, admin: adminData } = response.data;
    localStorage.setItem('tenome-admin-token', newToken);
    setToken(newToken);
    setAdmin(adminData);
    return adminData;
  };

  const register = async (email, password, name) => {
    const response = await axios.post(`${API}/admin/register`, { email, password, name });
    const { token: newToken, admin: adminData } = response.data;
    localStorage.setItem('tenome-admin-token', newToken);
    setToken(newToken);
    setAdmin(adminData);
    return adminData;
  };

  const logout = () => {
    localStorage.removeItem('tenome-admin-token');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{
      admin,
      token,
      loading,
      login,
      register,
      logout,
      isAuthenticated: !!admin
    }}>
      {children}
    </AuthContext.Provider>
  );
};
